import { Api, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutEdiEventStatusTableEdit } from "./autogen/AutogenLayoutEdiEventStatusTableEdit";
import { BlurEvent, ChangeEvent, Checkbox, ClickEvent, CrudDecorator, CrudDecoratorCloseEvent, DataHeaderProps, DataSourceMode, DropdownItem, DropdownSelectionEvent, Layout, LookupModelSearchEvent, LookupModelSelectionEvent, Panel, TableRow, TableRowCreationEvent, TableRowDisplayEvent, TableRowExpansionEvent, TableRowMoveEvent, Textbox,  DynamicDbDisplayValueSearchEvent, DataDisplayEvent,  TableRowMode, TableAction, TableContentsChangedEvent} from "@mcleod/components";
import { CrudDecoratorProps } from "@mcleod/components/src/page/decorators/CrudDecoratorProps";
import { EdiReqdFldGrpExpandedStatus } from "./EdiReqdFldGrpExpandedStatus";
import { EdiRequiredFieldStatus } from "./EdiRequiredFieldStatus";

export class EdiEventStatusTableEdit extends AutogenLayoutEdiEventStatusTableEdit {
    private _version: string;
    private _partner_id: string;
    private _direction: string;
    private _alt_partner_id: string;
    private static readonly OUTBOUND = "O";
    private static readonly INBOUND = "I";

    private _isLoadingData: boolean = false;

    private static readonly APPOINTMENT_EVENT_TYPE = "AP";
    private static readonly STOP_EVENT_TYPE = "ST";
    private static readonly POSITION_EVENT_TYPE = "LC";
    private static readonly ETA_EVENT_TYPE = "ET";
    private static readonly ORDER_HISTORY_EVENT_TYPE = "OH";
    private static readonly ARRIVE_STOP_EVENT_TYPE = "AS";
    private static readonly DEPART_STOP_EVENT_TYPE = "DS";
    private static readonly INFORMATIONAL_EVENT_TYPE = "IN";


    private static readonly ORIGIN_STOP_TYPE = "O";
    private static readonly PICKUP_STOP_TYPE = "P";

    private static readonly MINUTES_PER_HOUR = 60;
    private static readonly GRACE_PERIOD_HOURS = "grace_period_hours";
    private static readonly GRACE_PERIOD_MINUTES = "grace_period_minutes";
    private static readonly RESEND_EARLY_GRACE_PERIOD_HOURS = "resend_early_grace_period_hours";
    private static readonly RESEND_EARLY_GRACE_PERIOD_MINUTES = "resend_early_grace_period_minutes";
    private static readonly RESEND_LATE_GRACE_PERIOD_HOURS = "resend_late_grace_period_hours";
    private static readonly RESEND_LATE_GRACE_PERIOD_MINUTES = "resend_late_grace_period_minutes";
    private static readonly PICKUP_POS_PERIOD_HOURS = "pickup_pos_create_hours";
    private static readonly PICKUP_POS_PERIOD_MINUTES = "pickup_pos_create_minutes";
    private static readonly MINIMUM_INTERVAL_HOURS = "minimum_interval_hours";
    private static readonly MINIMUM_INTERVAL_MINUTES = "minimum_interval_minutes";

    private static readonly PICKUP_POS = "pickupPos";
    private static readonly GRACE_PERIOD = "gracePeriod";
    private static readonly RESEND_EARLY = "resendEarly";
    private static readonly RESEND_LATE = "resendLate";
    private static readonly MINIMUM_INTERVAL = "minimumInterval";

    // Field visibility configurations for different event types
    private static readonly FIELD_VISIBILITY_CONFIG = {
        [EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE]: {
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            checkboxApptConfirmed: true,
            textboxStatusRequired: true,
            textboxReqSrc: true,
            textboxGracePeriodHours: true,
            textboxGracePeriodMinutes: true,
            textboxDefaultDelayCode: true,
            textboxUnDelayCrossRef: true,
            textboxApptDateTable: true,
            textboxApptDateField: true,
            textboxStatusDateTable: true,
            textboxStatusDateField: true,
            textboxTimeRequired: true,
            panelResendCheckboxes: true,
            panelResendLabels: false,
            panelRequireCheckboxes: true,
            panelPositionText: false,
            imageResendOptions: false,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            panelResendOptions: true,
            textboxStopType: true,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false,
            textboxResendEarlyGracePeriodHours: true,
            textboxResendEarlyGracePeriodMinutes: true,
            textboxResendLateGracePeriodHours: true,
            textboxResendLateGracePeriodMinutes: true,
            textboxGracePeriodHoursResend: false,
            textboxGracePeriodMinutesResend: false,
            textboxPickupPosCreateHoursResend: false,
            textboxPickupPosCreateMinutesResend: false
        },
        [EdiEventStatusTableEdit.POSITION_EVENT_TYPE]: {
            pickup: {
                textboxCreateMethod: true,
                textboxPostedType: false,
                textboxXmitSequence: true,
                checkboxApptConfirmed: false,
                textboxStatusRequired: true,
                textboxReqSrc: true,
                textboxGracePeriodHours: false,
                textboxGracePeriodMinutes: false,
                textboxDefaultDelayCode: false,
                textboxUnDelayCrossRef: false,
                textboxApptDateTable: false,
                textboxApptDateField: false,
                textboxStatusDateTable: false,
                textboxStatusDateField: false,
                textboxTimeRequired: true,
                panelResendCheckboxes: false,
                panelResendLabels: true,
                panelRequireCheckboxes: false,
                panelPositionText: true,
                imageResendOptions: true,
                checkboxPickupPosPrevDelivered: true,
                textboxPickupPosCreateHours: true,
                textboxPickupPosCreateMinutes: true,
                imagePickupInfo: true,
                textboxPickupPosStopOption: true,
                panelResendOptions: true,
                textboxStopType: true,
                textboxCallin: false,
                textboxOrderHistory: false,
                textboxInStatusRequired: false,
                textboxReqSrcIn: false,
                checkboxShowOnReport: false,
                checkboxCommentsToStop: false,
                checkboxUpdateAppt: false,
                checkboxUpdateStopPieces: false,
                checkboxUpdateStopWeight: false,
                checkboxCreateServiceIncident: false,
                checkboxDepartCanArrive: false,
                textboxStatusDateTableIn: false,
                textboxStatusDateFieldIn: false,
                textboxResendEarlyGracePeriodHours: false,
                textboxResendEarlyGracePeriodMinutes: false,
                textboxResendLateGracePeriodHours: false,
                textboxResendLateGracePeriodMinutes: false,
                textboxGracePeriodHoursResend: true,
                textboxGracePeriodMinutesResend: true,
                textboxPickupPosCreateHoursResend: true,
                textboxPickupPosCreateMinutesResend: true
            },
            delivery: {
                textboxCreateMethod: true,
                textboxPostedType: false,
                textboxXmitSequence: true,
                checkboxApptConfirmed: false,
                textboxStatusRequired: true,
                textboxReqSrc: true,
                textboxGracePeriodHours: false,
                textboxGracePeriodMinutes: false,
                textboxDefaultDelayCode: false,
                textboxUnDelayCrossRef: false,
                textboxApptDateTable: false,
                textboxApptDateField: false,
                textboxStatusDateTable: false,
                textboxStatusDateField: false,
                textboxTimeRequired: true,
                panelResendCheckboxes: false,
                panelResendLabels: true,
                panelRequireCheckboxes: false,
                panelPositionText: true,
                imageResendOptions: true,
                checkboxPickupPosPrevDelivered: false,
                textboxPickupPosCreateHours: false,
                textboxPickupPosCreateMinutes: false,
                imagePickupInfo: false,
                textboxPickupPosStopOption: false,
                panelResendOptions: true,
                textboxStopType: true,
                textboxCallin: false,
                textboxOrderHistory: false,
                textboxInStatusRequired: false,
                textboxReqSrcIn: false,
                checkboxShowOnReport: false,
                checkboxCommentsToStop: false,
                checkboxUpdateAppt: false,
                checkboxUpdateStopPieces: false,
                checkboxUpdateStopWeight: false,
                checkboxCreateServiceIncident: false,
                checkboxDepartCanArrive: false,
                textboxStatusDateTableIn: false,
                textboxStatusDateFieldIn: false,
                textboxResendEarlyGracePeriodHours: false,
                textboxResendEarlyGracePeriodMinutes: false,
                textboxResendLateGracePeriodHours: false,
                textboxResendLateGracePeriodMinutes: false,
                textboxGracePeriodHoursResend: true,
                textboxGracePeriodMinutesResend: true,
                textboxPickupPosCreateHoursResend: true,
                textboxPickupPosCreateMinutesResend: true
            }
        },
        [EdiEventStatusTableEdit.ORDER_HISTORY_EVENT_TYPE]: {
            textboxCreateMethod: false,
            textboxPostedType: true,
            textboxXmitSequence: true,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: false,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            textboxTimeRequired: false,
            panelResendCheckboxes: false,
            panelResendLabels: false,
            panelRequireCheckboxes: false,
            panelPositionText: false,
            imageResendOptions: false,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            panelResendOptions: false,
            textboxStopType: false,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false,
            textboxResendEarlyGracePeriodHours: true,
            textboxResendEarlyGracePeriodMinutes: true,
            textboxResendLateGracePeriodHours: true,
            textboxResendLateGracePeriodMinutes: true,
            textboxGracePeriodHoursResend: false,
            textboxGracePeriodMinutesResend: false,
            textboxPickupPosCreateHoursResend: false,
            textboxPickupPosCreateMinutesResend: false
        },
        [EdiEventStatusTableEdit.ETA_EVENT_TYPE]: {
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: true,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: true,
            textboxUnDelayCrossRef: true,
            textboxApptDateTable: true,
            textboxApptDateField: true,
            textboxStatusDateTable: true,
            textboxStatusDateField: true,
            textboxTimeRequired: true,
            panelResendCheckboxes: false,
            panelResendLabels: true,
            panelRequireCheckboxes: false,
            panelPositionText: false,
            imageResendOptions: true,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            panelResendOptions: true,
            textboxStopType: true,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false,
            textboxResendEarlyGracePeriodHours: false,
            textboxResendEarlyGracePeriodMinutes: false,
            textboxResendLateGracePeriodHours: false,
            textboxResendLateGracePeriodMinutes: false,
            textboxGracePeriodHoursResend: true,
            textboxGracePeriodMinutesResend: true,
            textboxPickupPosCreateHoursResend: true,
            textboxPickupPosCreateMinutesResend: true
        },
        [EdiEventStatusTableEdit.STOP_EVENT_TYPE]: {
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: true,
            textboxGracePeriodHours: true,
            textboxGracePeriodMinutes: true,
            textboxDefaultDelayCode: true,
            textboxUnDelayCrossRef: true,
            textboxApptDateTable: true,
            textboxApptDateField: true,
            textboxStatusDateTable: true,
            textboxStatusDateField: true,
            textboxTimeRequired: true,
            panelResendCheckboxes: true,
            panelResendLabels: false,
            panelRequireCheckboxes: true,
            panelPositionText: false,
            imageResendOptions: false,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            panelResendOptions: true,
            textboxStopType: true,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false,
            textboxResendEarlyGracePeriodHours: true,
            textboxResendEarlyGracePeriodMinutes: true,
            textboxResendLateGracePeriodHours: true,
            textboxResendLateGracePeriodMinutes: true,
            textboxGracePeriodHoursResend: false,
            textboxGracePeriodMinutesResend: false,
            textboxPickupPosCreateHoursResend: false,
            textboxPickupPosCreateMinutesResend: false
        },
        [EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE]: {
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: false,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            textboxTimeRequired: false,
            panelResendCheckboxes: false,
            panelResendLabels: false,
            panelRequireCheckboxes: false,
            panelPositionText: false,
            imageResendOptions: false,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            panelResendOptions: false,
            textboxStopType: false,
            textboxResendEarlyGracePeriodHours: true,
            textboxResendEarlyGracePeriodMinutes: true,
            textboxResendLateGracePeriodHours: true,
            textboxResendLateGracePeriodMinutes: true,
            textboxGracePeriodHoursResend: false,
            textboxGracePeriodMinutesResend: false,
            textboxPickupPosCreateHoursResend: false,
            textboxPickupPosCreateMinutesResend: false
        }
    };

    private static readonly FIELD_REQUIRED_CONFIG = {
        [EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE]: {
            textboxStatusCode: true,
            textboxEventType: true,
            textboxStopType: true,
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            textboxBatchMethodReadOnly: false,
            textboxBatchMethod: false,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: true,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: true,
            textboxStatusDateField: true,
            textboxTimeRequired: true,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false
        },
        [EdiEventStatusTableEdit.POSITION_EVENT_TYPE]: {
            textboxStatusCode: true,
            textboxEventType: true,
            textboxStopType: true,
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            textboxBatchMethodReadOnly: false,
            textboxBatchMethod: false,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: true,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            textboxTimeRequired: true,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false

        },
        [EdiEventStatusTableEdit.ORDER_HISTORY_EVENT_TYPE]: {
            textboxStatusCode: true,
            textboxEventType: true,
            textboxStopType: false,
            textboxCreateMethod: false,
            textboxPostedType: true,
            textboxXmitSequence: true,
            textboxBatchMethodReadOnly: false,
            textboxBatchMethod: false,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: false,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            textboxTimeRequired: false,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false
        },
        [EdiEventStatusTableEdit.ETA_EVENT_TYPE]: {
            textboxStatusCode: true,
            textboxEventType: true,
            textboxStopType: true,
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            textboxBatchMethodReadOnly: false,
            textboxBatchMethod: false,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: true,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: true,
            textboxStatusDateField: true,
            textboxTimeRequired: true,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false
        },
        [EdiEventStatusTableEdit.STOP_EVENT_TYPE]: {
            textboxStatusCode: true,
            textboxEventType: true,
            textboxStopType: true,
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            textboxBatchMethodReadOnly: false,
            textboxBatchMethod: false,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: true,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: true,
            textboxStatusDateField: true,
            textboxTimeRequired: true,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false
        },
        [EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE]: {
            textboxStatusCode: true,
            textboxEventType: true,
            textboxStopType: false,
            textboxCreateMethod: true,
            textboxPostedType: false,
            textboxXmitSequence: true,
            textboxBatchMethodReadOnly: false,
            textboxBatchMethod: false,
            checkboxApptConfirmed: false,
            textboxStatusRequired: true,
            textboxReqSrc: false,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            textboxTimeRequired: false,
            checkboxPickupPosPrevDelivered: false,
            textboxPickupPosCreateHours: false,
            textboxPickupPosCreateMinutes: false,
            imagePickupInfo: false,
            textboxPickupPosStopOption: false,
            textboxCallin: false,
            textboxOrderHistory: false,
            textboxInStatusRequired: false,
            textboxReqSrcIn: false,
            checkboxShowOnReport: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxCreateServiceIncident: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateTableIn: false,
            textboxStatusDateFieldIn: false
        }
    };

    // Field visibility configuration for inbound general panel
    private static readonly INBOUND_GENERAL_FIELD_VISIBILITY_CONFIG = {
        [EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: true,
            checkboxUpdateAppt: true,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: true,
            checkboxUpdateStopWeight: true,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: true,
            textboxStatusDateTableIn: true,
            checkboxShowOnReport: true,
            textboxInStatusRequired: true,
            textboxCallin: true,
            textboxOrderHistory: true,
            // Ensure main fields are visible for appointments
            textboxCreateMethod: true,
            textboxStatusRequired: false,
            textboxReqSrc: false,
            textboxDefaultDelayCode: true,
            textboxUnDelayCrossRef: true,
            textboxApptDateTable: true,
            textboxApptDateField: true,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            textboxTimeRequired: true,
            checkboxApptConfirmed: true,
            textboxGracePeriodHours: true,
            textboxGracePeriodMinutes: true,
            // Hide resend panel components
            panelResendOptions: false,
            panelResendCheckboxes: false,
            panelResendLabels: false,
            imageResendOptions: false
        },
        [EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE]: {
            textboxReqSrcIn: true,
            checkboxCommentsToStop: true,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: true,
            checkboxUpdateStopPieces: true,
            checkboxUpdateStopWeight: true,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: true,
            textboxStatusDateTableIn: true,
            checkboxShowOnReport: true,
            textboxInStatusRequired: true,
            textboxCallin: true,
            textboxOrderHistory: true,
            // Hide outbound counterparts
            textboxStatusRequired: false,
            textboxReqSrc: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            panelResendOptions: false
        },
        [EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: true,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: true,
            checkboxUpdateStopWeight: true,
            checkboxDepartCanArrive: true,
            textboxStatusDateFieldIn: true,
            textboxStatusDateTableIn: true,
            checkboxShowOnReport: true,
            textboxInStatusRequired: true,
            textboxCallin: true,
            textboxOrderHistory: true,
            // Hide outbound counterparts
            textboxStatusRequired: false,
            textboxReqSrc: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            panelResendOptions: false
        },
        [EdiEventStatusTableEdit.POSITION_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: false,
            textboxStatusDateTableIn: false,
            checkboxShowOnReport: true,
            textboxInStatusRequired: true,
            textboxCallin: true,
            textboxOrderHistory: true,
            // Hide outbound counterparts
            textboxStatusRequired: false,
            textboxReqSrc: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            panelResendOptions: false,
            textboxStopType: false
        },
        [EdiEventStatusTableEdit.ETA_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: true,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: true,
            checkboxUpdateStopWeight: true,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: true,
            textboxStatusDateTableIn: true,
            checkboxShowOnReport: true,
            textboxInStatusRequired: true,
            textboxCallin: true,
            textboxOrderHistory: true,
            // Hide outbound counterparts
            textboxStatusRequired: false,
            textboxReqSrc: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            panelResendOptions: false
        },
        [EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: true,
            textboxStatusDateTableIn: true,
            checkboxShowOnReport: true,
            textboxInStatusRequired: true,
            textboxCallin: true,
            textboxOrderHistory: true,
            // Hide outbound counterparts
            textboxStatusRequired: false,
            textboxReqSrc: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            panelResendOptions: false,
            textboxStopType: false
        }
    };    // Field required configuration for inbound general panel
    private static readonly INBOUND_GENERAL_FIELD_REQUIRED_CONFIG = {
        [EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: true,
            textboxStatusDateTableIn: true,
            checkboxShowOnReport: false,
            textboxInStatusRequired: true,
            // Include main field requirements for inbound appointments
            textboxStatusCode: true,
            textboxEventType: true,
            textboxStopType: true,
            textboxCreateMethod: false,
            textboxStatusRequired: false,
            textboxReqSrc: false,
            textboxDefaultDelayCode: false,
            textboxUnDelayCrossRef: false,
            textboxApptDateTable: false,
            textboxApptDateField: false,
            textboxStatusDateTable: false,
            textboxStatusDateField: false,
            textboxTimeRequired: false,
            checkboxApptConfirmed: false,
            textboxGracePeriodHours: false,
            textboxGracePeriodMinutes: false
        },
        [EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: false,
            textboxStatusDateTableIn: false,
            checkboxShowOnReport: false,
            textboxInStatusRequired: true,
            textboxTimeRequired: false
        },
        [EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: false,
            textboxStatusDateTableIn: false,
            checkboxShowOnReport: false,
            textboxInStatusRequired: true,
            textboxTimeRequired: false
        },
        [EdiEventStatusTableEdit.POSITION_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: false,
            textboxStatusDateTableIn: false,
            checkboxShowOnReport: false,
            textboxInStatusRequired: true,
            textboxStatusDateField: false,
        },
        [EdiEventStatusTableEdit.ETA_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: false,
            textboxStatusDateTableIn: false,
            checkboxShowOnReport: false,
            textboxInStatusRequired: true
        },
        [EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE]: {
            textboxReqSrcIn: false,
            checkboxCommentsToStop: false,
            checkboxUpdateAppt: false,
            checkboxCreateServiceIncident: false,
            checkboxUpdateStopPieces: false,
            checkboxUpdateStopWeight: false,
            checkboxDepartCanArrive: false,
            textboxStatusDateFieldIn: false,
            textboxStatusDateTableIn: false,
            checkboxShowOnReport: false,
            textboxInStatusRequired: true,
            textboxStopType: false,
            textStatusDateField: false,
            textboxTimeRequired: false

        }
    };

    private static readonly NEW_RECORD = {
        textboxCreateMethod: true,
        textboxPostedType: false,
        textboxXmitSequence: true,
        checkboxApptConfirmed: false,
        textboxStatusRequired: true,
        textboxReqSrc: true,
        textboxGracePeriodHours: true,
        textboxGracePeriodMinutes: true,
        textboxDefaultDelayCode: false,
        textboxUnDelayCrossRef: false,
        textboxApptDateTable: true,
        textboxApptDateField: true,
        textboxStatusDateTable: true,
        textboxStatusDateField: true,
        textboxTimeRequired: true,
        panelResendCheckboxes: true,
        panelResendLabels: false,
        panelRequireCheckboxes: true,
        panelPositionText: false,
        imageResendOptions: false,
        checkboxPickupPosPrevDelivered: false,
        textboxPickupPosCreateHours: false,
        textboxPickupPosCreateMinutes: false,
        imagePickupInfo: false,
        textboxPickupPosStopOption: false,
        panelResendOptions: true,
        textboxStopType: true,
        textboxBatchMethodReadOnly: false,
        textboxBatchMethod: true,
        textboxCallin: false,
        textboxOrderHistory: false,
        textboxInStatusRequired: false,
        textboxReqSrcIn: false,
        checkboxShowOnReport: false,
        checkboxCommentsToStop: false,
        checkboxUpdateAppt: false,
        checkboxUpdateStopPieces: false,
        checkboxUpdateStopWeight: false,
        checkboxCreateServiceIncident: false,
        checkboxDepartCanArrive: false,
        textboxStatusDateTableIn: false,
        textboxStatusDateFieldIn: false,
        panelGeneral: true,
        textboxResendEarlyGracePeriodHours: false,
        textboxResendEarlyGracePeriodMinutes: false,
        textboxResendLateGracePeriodHours: false,
        textboxResendLateGracePeriodMinutes: false,
        textboxGracePeriodHoursResend: false,
        textboxGracePeriodMinutesResend: false,
        textboxPickupPosCreateHoursResend: false,
        textboxPickupPosCreateMinutesResend: false
    };
    private static readonly NEW_RECORD_INBOUND = {
        textboxCreateMethod: true,
        textboxPostedType: false,
        textboxXmitSequence: true,
        checkboxApptConfirmed: false,
        textboxStatusRequired: true,
        textboxReqSrc: true,
        textboxGracePeriodHours: false,
        textboxGracePeriodMinutes: false,
        textboxDefaultDelayCode: false,
        textboxUnDelayCrossRef: false,
        textboxApptDateTable: false,
        textboxApptDateField: false,
        textboxStatusDateTable: false,
        textboxStatusDateField: false,
        textboxTimeRequired: false,
        panelResendCheckboxes: false,
        panelResendLabels: false,
        panelRequireCheckboxes: false,
        panelPositionText: false,
        imageResendOptions: false,
        checkboxPickupPosPrevDelivered: false,
        textboxPickupPosCreateHours: false,
        textboxPickupPosCreateMinutes: false,
        imagePickupInfo: false,
        textboxPickupPosStopOption: false,
        panelResendOptions: false,
        textboxStopType: true,
        textboxBatchMethodReadOnly: false,
        textboxBatchMethod: true,
        textboxCallin: false,
        textboxOrderHistory: false,
        textboxInStatusRequired: false,
        textboxReqSrcIn: false,
        checkboxShowOnReport: true,
        checkboxCommentsToStop: true,
        checkboxUpdateAppt: false,
        checkboxUpdateStopPieces: false,
        checkboxUpdateStopWeight: false,
        checkboxCreateServiceIncident: false,
        checkboxDepartCanArrive: false,
        textboxStatusDateTableIn: true,
        panelGeneral: false,
        panelGeneralInbound: true,
        textboxStatusDateFieldIn: true,
        textboxStatusRequiredIn: true,
        textboxResendEarlyGracePeriodHours: false,
        textboxResendEarlyGracePeriodMinutes: false,
        textboxResendLateGracePeriodHours: false,
        textboxResendLateGracePeriodMinutes: false,
        textboxGracePeriodHoursResend: false,
        textboxGracePeriodMinutesResend: false,
        textboxPickupPosCreateHoursResend: false,
        textboxPickupPosCreateMinutesResend: false

    }

    // Dropdown item configurations
    private static readonly DROPDOWN_ITEMS = {
        TIME_REQUIRED_ALL: [
            new DropdownItem("N", "Do not create status"),
            new DropdownItem("E", "Create status in error"),
            new DropdownItem("A", "Accept as valid time")
        ],
        TIME_REQUIRED_NON_APPT: [
            new DropdownItem("E", "Create status in error"),
            new DropdownItem("A", "Accept as valid time")
        ],
        STOP_DATE_FIELDS: [
            new DropdownItem("sched_arrive", "Later of scheduled arrival times"),
            new DropdownItem("sched_arrive_early", "Early scheduled arrival time"),
            new DropdownItem("sched_arrive_late", "Late scheduled arrival time"),
            new DropdownItem("eta", "ETA"),
            new DropdownItem("actual_arrival", "Actual arrival time"),
            new DropdownItem("actual_departure", "Actual departure time")
        ],
        ORDER_DATE_FIELDS: [
            new DropdownItem("sched_arrive", "Later of scheduled arrival times")
        ],
        STATUS_DATE_TABLE: [
            new DropdownItem("stop", "Stop"),
            new DropdownItem("orders", "Orders")
        ],
        STATUS_DATE_TABLE_STOP_ONLY: [
            new DropdownItem("stop", "Stop")
        ],
        EVENT_TYPE_INBOUND: [
            new DropdownItem("AP", "Appointment"),
            new DropdownItem("AS", "Arrive stop"),
            new DropdownItem("DS", "Depart stop"),
            new DropdownItem("LC", "Position"),
            new DropdownItem("ET", "ETA"),
            new DropdownItem("IN", "Informational")
        ],
        EVENT_TYPE_OUTBOUND: [
            new DropdownItem("AP", "Appointment"),
            new DropdownItem("ST", "Stop"),
            new DropdownItem("LC", "Position"),
            new DropdownItem("ET", "ETA"),
            new DropdownItem("OH", "Order history")
        ],
        INFORMATIONAL_STATUS_FIELDS: [
            new DropdownItem("dray_pu_date", "Dray pickup date"),
            new DropdownItem("dray_pu_xfer_dt", "Dray pickup transfer date"),
            new DropdownItem("dray_del_date", "Dray delivery date"),
            new DropdownItem("dray_del_xfer_dt", "Dray delivery transfer date"),
            new DropdownItem("load_date", "Load date"),
            new DropdownItem("sail_date", "Sail date"),
            new DropdownItem("vessel_cutoff_date", "Vessel cutoff date")
        ],
        APPOINTMENT_STATUS_FIELDS: [
            new DropdownItem("sched_arrive*", "Early and late scheduled arrival times"),
            new DropdownItem("sched_arrive_early", "Early scheduled arrival time"),
            new DropdownItem("sched_arrive_late", "Late scheduled arrival time")
        ],
        STATUS_REQUIRED_INBOUND_FIELDS: [
            new DropdownItem("Y", "Required"),
            new DropdownItem("O", "Optional")
        ],
        SRC_REQUIRED_INBOUND_FIELDS: [
            new DropdownItem("N", "SRC Not required"),
            new DropdownItem("Y", "Require SRC")
        ]
    };

    // Default field values configuration for add operations
    private static readonly ADD_FIELD_DEFAULTS = {
        [EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE]: {
            grace_period_hours: 0,
            grace_period_minutes: 0,
            grace_period: 0,
            appt_date_table: "stop",
            appt_date_field: "sched_arrive*",
            status_date_table: "stop",
            status_date_field: "sched_arrive*",
            resend_if_early: true,
            resend_if_late: true,
            resend_early_grace_period_hours: 0,
            resend_early_grace_period_minutes: 1,
            resend_early_grace: 1,
            resend_late_grace_period_hours: 0,
            resend_late_grace_period_minutes: 1,
            resend_late_grace: 1,
            pickup_pos_lead_time: 0,
            pickup_pos_create_hours: 0,
            pickup_pos_create_minutes: 0
        },
        [EdiEventStatusTableEdit.POSITION_EVENT_TYPE]: {
            grace_period_hours: 0,
            grace_period_minutes: 0,
            grace_period: 0,
            appt_date_table: null,
            appt_date_field: null,
            status_date_table: null,
            status_date_field: null,
            resend_if_early: false,
            resend_if_late: false,
            resend_early_grace_period_hours: 0,
            resend_early_grace_period_minutes: 1,
            resend_early_grace: 1,
            resend_late_grace_period_hours: 0,
            resend_late_grace_period_minutes: 0,
            resend_late_grace: 0,
            pickup_pos_lead_time: 0,
            pickup_pos_create_hours: 0,
            pickup_pos_create_minutes: 0
        },
        [EdiEventStatusTableEdit.ORDER_HISTORY_EVENT_TYPE]: {
            grace_period_hours: 0,
            grace_period_minutes: 0,
            grace_period: 0,
            appt_date_table: null,
            appt_date_field: null,
            status_date_table: null,
            status_date_field: null,
            resend_if_early: false,
            resend_if_late: false,
            resend_early_grace_period_hours: 0,
            resend_early_grace_period_minutes: 0,
            resend_early_grace: 0,
            resend_late_grace_period_hours: 0,
            resend_late_grace_period_minutes: 0,
            resend_late_grace: 0,
            pickup_pos_lead_time: 0,
            pickup_pos_create_hours: 0,
            pickup_pos_create_minutes: 0
        },
        [EdiEventStatusTableEdit.ETA_EVENT_TYPE]: {
            grace_period_hours: 0,
            grace_period_minutes: 0,
            grace_period: 0,
            appt_date_table: "stop",
            appt_date_field: "eta",
            status_date_table: "stop",
            status_date_field: "eta",
            resend_if_early: false,
            resend_if_late: false,
            resend_early_grace_period_hours: 0,
            resend_early_grace_period_minutes: 1,
            resend_early_grace: 1,
            resend_late_grace_period_hours: 0,
            resend_late_grace_period_minutes: 0,
            resend_late_grace: 0,
            pickup_pos_lead_time: 0,
            pickup_pos_create_hours: 0,
            pickup_pos_create_minutes: 0
        },
        [EdiEventStatusTableEdit.STOP_EVENT_TYPE]: {
            grace_period_hours: 0,
            grace_period_minutes: 0,
            grace_period: 0,
            appt_date_table: "stop",
            appt_date_field: "sched_arrive*",
            status_date_table: "stop",
            status_date_field: "actual_arrival",
            resend_if_early: false,
            resend_if_late: false,
            resend_early_grace_period_hours: 0,
            resend_early_grace_period_minutes: 0,
            resend_early_grace: 0,
            resend_late_grace_period_hours: 0,
            resend_late_grace_period_minutes: 0,
            resend_late_grace: 0,
            pickup_pos_lead_time: 0,
            pickup_pos_create_hours: 0,
            pickup_pos_create_minutes: 0
        },
        [EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE]: {
            grace_period_hours: 0,
            grace_period_minutes: 0,
            grace_period: 0,
            appt_date_table: null,
            appt_date_field: null,
            status_date_table: null,
            status_date_field: null,
            resend_if_early: false,
            resend_if_late: false,
            resend_early_grace_period_hours: 0,
            resend_early_grace_period_minutes: 0,
            resend_early_grace: 0,
            resend_late_grace_period_hours: 0,
            resend_late_grace_period_minutes: 0,
            resend_late_grace: 0,
            pickup_pos_lead_time: 0,
            pickup_pos_create_hours: 0,
            pickup_pos_create_minutes: 0
        }
    };

    // Default field values configuration for add operations - Inbound events
    private static readonly INBOUND_ADD_FIELD_DEFAULTS = {
        [EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE]: {
            status_date_table: "stop",
            status_date_field: "sched_arrive*",
            show_on_rpt: false
        },
        [EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE]: {
            status_date_table: "stop",
            status_date_field: "actual_arrival",
            show_on_rpt: false
        },
        [EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE]: {
            status_date_table: "stop",
            status_date_field: "actual_departure",
            show_on_rpt: false
        },
        [EdiEventStatusTableEdit.POSITION_EVENT_TYPE]: {
            status_date_table: "stop",
            status_date_field: null,
            show_on_rpt: false
        },
        [EdiEventStatusTableEdit.ETA_EVENT_TYPE]: {
            status_date_table: "stop",
            status_date_field: "eta",
            show_on_rpt: false
        },
        [EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE]: {
            status_date_table: "orders",
            status_date_field: null,
            show_on_rpt: false
        }
    };

    private readonly HELP_WINDOW_CSS = `
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          padding: 20px;
          line-height: 1.6;
          color: #333;
          max-width: 800px;
        }
        h1 {
          color: #2c5282;
          border-bottom: 2px solid #e2e8f0;
          padding-bottom: 10px;
        }
        h2 {
          color: #2d3748;
          margin-top: 0;
        }
        h3 {
          color: #4a5568;
          margin-top: 25px;
          margin-bottom: 15px;
        }
        h4 {
          color: #2d3748;
          margin-bottom: 8px;
          margin-top: 15px;
        }
        code {
          background-color: #f7fafc;
          padding: 2px 6px;
          border-radius: 3px;
          font-family: 'Courier New', monospace;
          color: #e53e3e;
          font-weight: bold;
        }
        ul {
          margin: 10px 0;
          padding-left: 20px;
        }
        li {
          margin-bottom: 8px;
        }
        .example {
          background-color: #f8f9fa;
          border-left: 4px solid #4299e1;
          padding: 15px;
          margin: 15px 0;
          border-radius: 0 4px 4px 0;
        }
        .example h4 {
          margin-top: 0;
          color: #2b6cb0;
        }
        .example p {
          margin: 8px 0;
        }
        strong {
          color: #2d3748;
        }
        em {
          color: #718096;
          background-color: #edf2f7;
          padding: 8px;
          border-radius: 4px;
          display: block;
          margin: 15px 0;
        }
        .placeholder {
          color: #333;
        }
      `;

    private static readonly TRANSACTION_SET_214 = "214";

    override async onLoad() {
        this.textboxApptDateTable.lookupModelDisabled = true;
        this.textboxApptDateField.lookupModelDisabled = true;
        this.setupTableRequiredFieldHandlers(EdiEventStatusTableEdit.TRANSACTION_SET_214, false);
        this.layoutEventSchedule.sourceEdischedule.addValidationListener((event) => {
            const validation = this.layoutEventSchedule.validateScheduleFields();

            // Set validation result - if fields are required but not valid, fail validation
            if (validation.hasCheckedBoxes && !validation.isValid) {
                event.validationResults.push({
                    isValid: false,
                    validationMessage: "Start time and frequency are required when transmission schedule is configured.",
                    component: this.layoutEventSchedule
                });
            }
        });
    }

    afterExecution() {
        const addMode = this.mainDataSource?.mode === DataSourceMode.ADD;
        if (addMode) {
            this.mainDataSource.activeRow.set("partner_id", this.partnerId);
            this.mainDataSource.activeRow.set("version", this.version);
            this.mainDataSource.activeRow.set("direction", this.direction);
            this.mainDataSource.activeRow.set("alt_partner_id", this.altPartnerId);
            this.tableRequiredField.dataSource.setRowsAndMode(DataSourceMode.NONE, []);
            this.tableReqdFldGrp.dataSource.setRowsAndMode(DataSourceMode.NONE, []);
            this.setAddVisibility();
        } else {
            this.setBatchMethodFields();
            this.setFieldVisibility();
            this.setFieldRequired();
            this.setPanelBorderColor();
            this.setEnabledFields();
        }
        this.setDirectionVisibility(this.mainDataSource?.activeRow?.get("direction"));
            this.setEventTypeItemsByDirection(this.mainDataSource?.activeRow?.get("direction"));
            if ("I" === this.mainDataSource?.activeRow?.get("direction")) {
                this.textboxInStatusRequired.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STATUS_REQUIRED_INBOUND_FIELDS;
                this.textboxReqSrcIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.SRC_REQUIRED_INBOUND_FIELDS;
            }
        if (this.mainDataSource?.activeRow && !addMode) {
            // Perform actions after execution
            if (this.mainDataSource.activeRow.get("event_type") === EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE) {
                this.textboxTimeRequired.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.TIME_REQUIRED_ALL;
                this.textboxTimeRequired.selectedItem = EdiEventStatusTableEdit.DROPDOWN_ITEMS.TIME_REQUIRED_ALL.find(item => item.value === this.mainDataSource?.activeRow?.get("time_required"));
            }
            const requiredFields = this.mainDataSource.activeRow.get("required_fields");
            if (requiredFields) {
                const modelRows: ModelRow[] = [];
                requiredFields.forEach((field: any) => {
                    const row = new ModelRow("lme/datafusion/edi-required-field");
                    this.mapRequiredFieldToModelRow(row, field);
                    modelRows.push(row);
                });
                this.tableRequiredField.dataSource.setRowsAndMode(DataSourceMode.NONE, modelRows);
            }
            this.layoutEventSchedule.sourceEdischedule.search({ "parent_row_id": this.mainDataSource?.activeRow?.get("id"), "parent_row_type": "E" });
            if (!this.layoutEventSchedule.sourceEdischedule.activeRow) {
                this.layoutEventSchedule.textboxStart.required = false;
                this.layoutEventSchedule.textboxFrequency.required = false;
            }
            const creationRules = this.mainDataSource.activeRow.get("creation_rules");
            if (creationRules) {
                const modelRows: ModelRow[] = [];
                creationRules.forEach((field: any) => {
                    const row = new ModelRow("lme/datafusion/edi-reqdfldgroup");
                    this.mapCreationRuleToModelRow(row, field);
                    modelRows.push(row);
                });
                this.tableReqdFldGrp.dataSource.setRowsAndMode(DataSourceMode.NONE, modelRows);
            }
            this.updateReqdFldGrpQuickAddSequence();
        }
    }
    setDirectionVisibility(direction: string) {
        if (direction === EdiEventStatusTableEdit.OUTBOUND) {
            this.tabSchedule.visible = this.mainDataSource.activeRow?.get("event_type") === EdiEventStatusTableEdit.POSITION_EVENT_TYPE ||
                this.mainDataSource.activeRow?.get("event_type") === EdiEventStatusTableEdit.ETA_EVENT_TYPE;
        } else {
            this.tabSchedule.visible = false;
        }
        this.tabCreationRules.visible = (direction === EdiEventStatusTableEdit.OUTBOUND);
        this.tabDataValidation.visible = (direction === EdiEventStatusTableEdit.OUTBOUND);
        this.panelGeneral.visible = (direction === EdiEventStatusTableEdit.OUTBOUND);
        this.panelGeneralInbound.visible = (direction === EdiEventStatusTableEdit.INBOUND);

        // Unbind duplicate-field components on the hidden panel so they don't
        // overwrite model values during _updateRowFromBoundComponents on save.
        if (direction === EdiEventStatusTableEdit.OUTBOUND) {
            this.textboxStatusDateFieldIn.field = null;
            this.textboxStatusDateTableIn.field = null;
            this.textboxInStatusRequired.field = null;
            this.textboxReqSrcIn.field = null;
            this.textboxOrderHistory.field = null;
        } else if (direction === EdiEventStatusTableEdit.INBOUND) {
            this.textboxStatusDateField.field = null;
            this.textboxStatusDateTable.field = null;
            this.textboxStatusRequired.field = null;
            this.textboxReqSrc.field = null;
            this.textboxPostedType.field = null;
        }
    }
    setEventTypeItemsByDirection(direction: string) {
        if (direction === EdiEventStatusTableEdit.INBOUND) {
            this.textboxEventType.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.EVENT_TYPE_INBOUND;
        } else if (direction === EdiEventStatusTableEdit.OUTBOUND) {
            this.textboxEventType.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.EVENT_TYPE_OUTBOUND;
        }
    }
    setGeneralPanelInboundVisibility() {
        const eventType = this.mainDataSource?.activeRow?.get("event_type");
        const departCanArrive = this.mainDataSource?.activeRow?.getBoolean("depart_can_arrive");

        // Set common properties for all event types
        this.textboxStatusDateFieldIn.lookupModelDisabled = true;
        this.textboxStatusDateTableIn.lookupModelDisabled = true;
        // For inbound events, we need to set visibility for ALL fields since we don't apply
        // the main FIELD_VISIBILITY_CONFIG. Get the inbound configuration.
        const visibilityConfig = EdiEventStatusTableEdit.INBOUND_GENERAL_FIELD_VISIBILITY_CONFIG[eventType];


        if (visibilityConfig) {
            // Apply the inbound configuration which now includes both inbound-specific
            // fields AND main form fields
            this.applyInboundGeneralFieldVisibilityConfig(visibilityConfig);
        }

        this.textboxStatusDateFieldIn.allowDropdownBlank = (eventType !== EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE);

        // Set status date table dropdown items for inbound events
        this.textboxStatusDateTableIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STATUS_DATE_TABLE;

        // Set SRC required dropdown items for inbound events
        this.textboxReqSrcIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.SRC_REQUIRED_INBOUND_FIELDS;

        // Handle special cases for dropdown items
        if (eventType === EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE) {
            this.textboxStatusDateFieldIn.enabled = true;
            this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.INFORMATIONAL_STATUS_FIELDS;
        } else if (eventType === EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE) {
            this.textboxStatusDateFieldIn.enabled = true;
            this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.APPOINTMENT_STATUS_FIELDS;
        } else if (eventType === EdiEventStatusTableEdit.ETA_EVENT_TYPE ||
            eventType === EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE ||
            eventType === EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE) {
            this.textboxStatusDateFieldIn.enabled = false;
            // For ETA and stop events, use stop date fields since status_date_table is "stop"
            this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STOP_DATE_FIELDS;
        } else {
            this.textboxStatusDateFieldIn.enabled = false;
        }
        if (eventType === EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE || (eventType === EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE && departCanArrive)) {
            this.textboxReqSrcIn.visible = true;
            this.checkboxCreateServiceIncident.visible = true;
        }
    }
    setGeneralPanelInboundRequired() {
        const eventType = this.mainDataSource?.activeRow?.get("event_type");
        const requiredConfig = EdiEventStatusTableEdit.INBOUND_GENERAL_FIELD_REQUIRED_CONFIG[eventType];

        if (requiredConfig) {
            this.applyInboundGeneralFieldRequiredConfig(requiredConfig);
        }
    }
    appointmentDateOnDropdownSelectionEvent(event: DropdownSelectionEvent) {
        this.handleDateFieldDropdownSelection(event, this.textboxApptDateField);
    }

    statusDateOnDropdownSelectionEvent(event: DropdownSelectionEvent) {
        this.handleDateFieldDropdownSelection(event, this.textboxStatusDateField);
    }

    statusDateInOnDropdownSelectionEvent(event: DropdownSelectionEvent) {
        this.handleDateFieldDropdownSelection(event, this.textboxStatusDateFieldIn);
    }

    /**
     * Common handler for date field dropdown selection events
     * @param event The dropdown selection event
     * @param textbox The textbox to update with new items
     */
    private handleDateFieldDropdownSelection(event: DropdownSelectionEvent, textbox: any) {
        if (!event.userInitiatedChange) {
            return;
        }

        const isStop = event.selection?.value === "stop";
        textbox.items = isStop
            ? EdiEventStatusTableEdit.DROPDOWN_ITEMS.STOP_DATE_FIELDS
            : EdiEventStatusTableEdit.DROPDOWN_ITEMS.ORDER_DATE_FIELDS;
        textbox.displayData(this.mainDataSource?.activeRow, null, 0);
    }

    earlierCheckboxOnChange(event: ChangeEvent) {
        this.handleCheckboxChange(event, this.checkboxResendIfEarly, this.checkboxResendEarReqSrc);
    }

    laterCheckboxOnChange(event: ChangeEvent) {
        this.handleCheckboxChange(event, this.checkboxResendIfLate, this.checkboxResendLatReqSrc);
    }

    private handleCheckboxChange(event: ChangeEvent, checkBox: Checkbox, checkBoxSrc: Checkbox) {
        if (!event.userInitiatedChange) {
            return;
        }
        if (!checkBox.checked) {
            checkBoxSrc.checked = false;
            checkBoxSrc.enabled = false;
        } else {
            checkBoxSrc.enabled = true;
        }

    }

    defaultDelayCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.partner_id = this.mainDataSource?.activeRow?.get("partner_id");
        event.filter.version = this.mainDataSource?.activeRow?.get("version");
    }

    statusCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.version = this.mainDataSource?.activeRow?.get("version", this.version);
        event.filter.transaction_set = "214";
    }

    gracePeriodHoursOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, true, EdiEventStatusTableEdit.GRACE_PERIOD);
    }

    gracePeriodMinutesOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, false, EdiEventStatusTableEdit.GRACE_PERIOD);
    }

    resendEarlyHoursOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, true, EdiEventStatusTableEdit.RESEND_EARLY);
    }

    resendEarlyMinutesOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, false, EdiEventStatusTableEdit.RESEND_EARLY);
    }

    resendLateHoursOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, true, EdiEventStatusTableEdit.RESEND_LATE);
    }

    resendLateMinutesOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, false, EdiEventStatusTableEdit.RESEND_LATE);
    }

    pickupPosHoursOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, true, EdiEventStatusTableEdit.PICKUP_POS);
    }

    pickupPosMinutesOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, false, EdiEventStatusTableEdit.PICKUP_POS);
    }

    minimumIntervalHoursOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, true, EdiEventStatusTableEdit.MINIMUM_INTERVAL);
    }

    minimumIntervalMinutesOnBlur(event: BlurEvent) {
        this.handleIntervalValueOnBlur(event, false, EdiEventStatusTableEdit.MINIMUM_INTERVAL);
    }

    /**
     * Unified handler for all interval value blur events
     * @param event The blur event
     * @param isHours Whether this is for hours (true) or minutes (false)
     * @param intervalType The type of interval (gracePeriod, resendEarly, resendLate)
     */
    private handleIntervalValueOnBlur(event: BlurEvent, isHours: boolean, intervalType: string) {
        const fieldConfig = this.getIntervalFieldConfig(intervalType);
        this.intervalValueOnBlur(
            event,
            isHours,
            fieldConfig.hoursField,
            fieldConfig.minutesField,
            fieldConfig.databaseField
        );
    }

    /**
     * Gets the field configuration for a specific interval type
     * @param intervalType The type of interval (gracePeriod, resendEarly, resendLate)
     * @returns Configuration object with field names
     */
    private getIntervalFieldConfig(intervalType: string) {
        const configs = {
            gracePeriod: {
                hoursField: EdiEventStatusTableEdit.GRACE_PERIOD_HOURS,
                minutesField: EdiEventStatusTableEdit.GRACE_PERIOD_MINUTES,
                databaseField: "grace_period"
            },
            resendEarly: {
                hoursField: EdiEventStatusTableEdit.RESEND_EARLY_GRACE_PERIOD_HOURS,
                minutesField: EdiEventStatusTableEdit.RESEND_EARLY_GRACE_PERIOD_MINUTES,
                databaseField: "resend_early_grace"
            },
            resendLate: {
                hoursField: EdiEventStatusTableEdit.RESEND_LATE_GRACE_PERIOD_HOURS,
                minutesField: EdiEventStatusTableEdit.RESEND_LATE_GRACE_PERIOD_MINUTES,
                databaseField: "resend_late_grace"
            },
            pickupPos: {
                hoursField: EdiEventStatusTableEdit.PICKUP_POS_PERIOD_HOURS,
                minutesField: EdiEventStatusTableEdit.PICKUP_POS_PERIOD_MINUTES,
                databaseField: "pickup_pos_lead_time"
            },
            minimumInterval: {
                hoursField: EdiEventStatusTableEdit.MINIMUM_INTERVAL_HOURS,
                minutesField: EdiEventStatusTableEdit.MINIMUM_INTERVAL_MINUTES,
                databaseField: "minimum_interval"
            }
        };
        return configs[intervalType];
    }

    private intervalValueOnBlur(event: BlurEvent, isHours: boolean, hours: string, minutes: string, databaseField: string) {
        if (event.changedWhileFocused) {
            const textbox = event.target as Textbox;
            if (StringUtil.isEmptyString(textbox.text)) {
                if (isHours) {
                    this.mainDataSource?.activeRow?.set(hours, 0);
                } else {
                    this.mainDataSource?.activeRow?.set(minutes, 0);
                }
            }
            this.updateAuditInterval(
                this.mainDataSource?.activeRow?.getNumber(hours) ?? 0,
                this.mainDataSource?.activeRow?.getNumber(minutes) ?? 0,
                hours,
                minutes,
                databaseField
            );
        }
    }

    setBatchMethodFields() {
        const batchMethod = this.mainDataSource?.activeRow?.get("batch_method_read_only") === "E";
        if (!batchMethod) {
            this.textboxBatchMethodReadOnly.visible = true;
            this.textboxBatchMethod.visible = false;
        } else {
            this.textboxBatchMethodReadOnly.visible = false;
            this.textboxBatchMethod.visible = true;
        }
    }

    updateAuditInterval(hoursValueInput: number, minutesValueInput: number, hoursField: string, minutesField: string, databaseField: string) {
        const totalMinutes = hoursValueInput * EdiEventStatusTableEdit.MINUTES_PER_HOUR + minutesValueInput;
        this.mainDataSource?.activeRow?.set(databaseField, totalMinutes);
        let intervalHours = hoursValueInput;
        let intervalMinutes = minutesValueInput;
        if (minutesValueInput >= EdiEventStatusTableEdit.MINUTES_PER_HOUR) {
            intervalHours += Math.floor(minutesValueInput / EdiEventStatusTableEdit.MINUTES_PER_HOUR);
            intervalMinutes = minutesValueInput % EdiEventStatusTableEdit.MINUTES_PER_HOUR;
        }
        this.mainDataSource?.activeRow?.set(hoursField, intervalHours);
        this.mainDataSource?.activeRow?.set(minutesField, intervalMinutes);
    }

    imagePickupInfoOnClick(event: ClickEvent) {
        this.openHelpWindow(
            'Pickup Position Option Information',
            this.getPickupInfoContent()
        );
    }

    imageResendInfoOnClick(event: ClickEvent) {
        this.openHelpWindow(
            'ETA/Position Resend Information',
            this.getResendInfoContent()
        );
    }

    eventTypeAfterDropDownSelection(event: DropdownSelectionEvent) {
        if (!event.userInitiatedChange) {
            return;
        }
        const modeAdd = this.mainDataSource?.mode === DataSourceMode.ADD;
        if (modeAdd) {
            this.setAddField(event);
        }
        this.setFieldVisibility();
        this.setFieldRequired();
        this.setPanelBorderColor();
        this.setStatusDateTableItems(event);

        // Update inbound general panel visibility when event type changes for inbound events
        const direction = this.mainDataSource?.activeRow?.get("direction");
        const eventType = event.selection?.value;

        if (direction === EdiEventStatusTableEdit.OUTBOUND) {
            this.setupOutboundEventTypeChange(eventType, modeAdd);
        } else if (direction === EdiEventStatusTableEdit.INBOUND) {
            this.setupInboundEventTypeChange(eventType, modeAdd);
        }
    }

    private setupOutboundEventTypeChange(eventType: string, isAddMode: boolean) {
        // Update time required dropdown items based on event type
        this.setupTimeRequiredItems(eventType);

        // Update Schedule tab visibility (only visible for Position and ETA)
        this.tabSchedule.visible = eventType === EdiEventStatusTableEdit.POSITION_EVENT_TYPE ||
            eventType === EdiEventStatusTableEdit.ETA_EVENT_TYPE;

        // Always set defaults when event type changes (mimics Swing doOnEventTypeValueChanged behavior)
        this.setOutboundEventTypeDefaults(eventType, isAddMode);
    }

    private setupInboundEventTypeChange(eventType: string, isAddMode: boolean) {
        this.setGeneralPanelInboundVisibility();
        this.setInboundStatusDateFields();

        // Reset depart_can_arrive when event type is not Depart Stop
        if (eventType !== EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE) {
            this.mainDataSource?.activeRow?.set("depart_can_arrive", false);
            if (this.checkboxDepartCanArrive) {
                this.checkboxDepartCanArrive.checked = false;
            }
        }

        // Reset service incident options when not arrive stop (or depart+departCanArrive)
        const departCanArrive = this.mainDataSource?.activeRow?.getBoolean("depart_can_arrive");
        if (eventType !== EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE &&
            !(eventType === EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE && departCanArrive)) {
            this.mainDataSource?.activeRow?.set("req_src", "N");
            this.mainDataSource?.activeRow?.set("create_service_inc", false);
            if (this.checkboxCreateServiceIncident) {
                this.checkboxCreateServiceIncident.checked = false;
            }
        }

        // Set default status date values when event type changes (mimics Swing setDefaultStatusDateForEventType)
        this.setInboundEventTypeDefaults(eventType, isAddMode);
    }

    private setupTimeRequiredItems(eventType: string) {
        if (eventType === EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE ||
            eventType === EdiEventStatusTableEdit.STOP_EVENT_TYPE) {
            this.textboxTimeRequired.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.TIME_REQUIRED_ALL;
        } else if (eventType === EdiEventStatusTableEdit.ETA_EVENT_TYPE ||
            eventType === EdiEventStatusTableEdit.POSITION_EVENT_TYPE) {
            this.textboxTimeRequired.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.TIME_REQUIRED_NON_APPT;
        }

        // Preserve current selection if still valid in the new item set
        const currentValue = this.mainDataSource?.activeRow?.get("time_required");
        if (currentValue && Array.isArray(this.textboxTimeRequired.items)) {
            const matchingItem = (this.textboxTimeRequired.items as DropdownItem[]).find(
                item => item.value === currentValue
            );
            if (matchingItem) {
                this.textboxTimeRequired.selectedItem = matchingItem;
            }
        }
    }

    private setOutboundEventTypeDefaults(eventType: string, isAddMode: boolean) {
        // Always apply status date, appt date, and grace period defaults when event type changes
        // (mimics Swing doOnEventTypeValueChanged behavior which sets these regardless of add/update mode)
        if (eventType === EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE) {
            this.mainDataSource?.activeRow?.set("status_date_table", "stop");
            this.mainDataSource?.activeRow?.set("status_date_field", "sched_arrive*");
            this.mainDataSource?.activeRow?.set("appt_date_table", "stop");
            this.mainDataSource?.activeRow?.set("appt_date_field", "sched_arrive*");
            this.mainDataSource?.activeRow?.set("grace_period_hours", 0);
            this.mainDataSource?.activeRow?.set("grace_period_minutes", 0);
            this.mainDataSource?.activeRow?.set("grace_period", 0);

            // Resend access enabled (Swing: setResendAccess(true) - enables without resetting)
            if (this.checkboxResendIfEarly) {
                this.checkboxResendIfEarly.enabled = true;
            }
            if (this.checkboxResendIfLate) {
                this.checkboxResendIfLate.enabled = true;
            }

            // Only auto-check resend boxes and set grace in add mode (Swing: inAddExecMode guard)
            if (isAddMode) {
                this.mainDataSource?.activeRow?.set("resend_if_early", true);
                this.mainDataSource?.activeRow?.set("resend_early_grace_period_hours", 0);
                this.mainDataSource?.activeRow?.set("resend_early_grace_period_minutes", 1);
                this.mainDataSource?.activeRow?.set("resend_early_grace", 1);
                this.mainDataSource?.activeRow?.set("resend_if_late", true);
                this.mainDataSource?.activeRow?.set("resend_late_grace_period_hours", 0);
                this.mainDataSource?.activeRow?.set("resend_late_grace_period_minutes", 1);
                this.mainDataSource?.activeRow?.set("resend_late_grace", 1);
                if (this.checkboxResendIfEarly) {
                    this.checkboxResendIfEarly.checked = true;
                }
                if (this.checkboxResendIfLate) {
                    this.checkboxResendIfLate.checked = true;
                }
            }
            this.checkboxResendEarReqSrc.enabled = this.checkboxResendIfEarly?.checked ?? false;
            this.checkboxResendLatReqSrc.enabled = this.checkboxResendIfLate?.checked ?? false;
        } else if (eventType === EdiEventStatusTableEdit.STOP_EVENT_TYPE) {
            this.mainDataSource?.activeRow?.set("status_date_table", "stop");
            this.mainDataSource?.activeRow?.set("status_date_field", "actual_arrival");
            this.mainDataSource?.activeRow?.set("appt_date_table", "stop");
            this.mainDataSource?.activeRow?.set("appt_date_field", "sched_arrive*");
            this.mainDataSource?.activeRow?.set("grace_period_hours", 0);
            this.mainDataSource?.activeRow?.set("grace_period_minutes", 0);
            this.mainDataSource?.activeRow?.set("grace_period", 0);

            // Stop events: resend access enabled but reset to default values (Swing: setResendAccess(true, true))
            this.mainDataSource?.activeRow?.set("resend_if_early", false);
            this.mainDataSource?.activeRow?.set("resend_early_grace_period_hours", 0);
            this.mainDataSource?.activeRow?.set("resend_early_grace_period_minutes", 0);
            this.mainDataSource?.activeRow?.set("resend_early_grace", 0);
            this.mainDataSource?.activeRow?.set("resend_if_late", false);
            this.mainDataSource?.activeRow?.set("resend_late_grace_period_hours", 0);
            this.mainDataSource?.activeRow?.set("resend_late_grace_period_minutes", 0);
            this.mainDataSource?.activeRow?.set("resend_late_grace", 0);
            if (this.checkboxResendIfEarly) {
                this.checkboxResendIfEarly.checked = false;
                this.checkboxResendIfEarly.enabled = true;
            }
            if (this.checkboxResendIfLate) {
                this.checkboxResendIfLate.checked = false;
                this.checkboxResendIfLate.enabled = true;
            }
            this.checkboxResendEarReqSrc.checked = false;
            this.checkboxResendEarReqSrc.enabled = false;
            this.checkboxResendLatReqSrc.checked = false;
            this.checkboxResendLatReqSrc.enabled = false;
        } else if (eventType === EdiEventStatusTableEdit.POSITION_EVENT_TYPE ||
            eventType === EdiEventStatusTableEdit.ETA_EVENT_TYPE) {
            // ETA: status_date=stop/eta, appt_date=stop/eta, grace=0/1
            // Position: status_date=mc_position/position_date, appt_date=mc_position/position_date, grace=0/1
            if (eventType === EdiEventStatusTableEdit.ETA_EVENT_TYPE) {
                this.mainDataSource?.activeRow?.set("status_date_table", "stop");
                this.mainDataSource?.activeRow?.set("status_date_field", "eta");
                this.mainDataSource?.activeRow?.set("appt_date_table", "stop");
                this.mainDataSource?.activeRow?.set("appt_date_field", "eta");
            } else {
                this.mainDataSource?.activeRow?.set("status_date_table", "mc_position");
                this.mainDataSource?.activeRow?.set("status_date_field", "position_date");
                this.mainDataSource?.activeRow?.set("appt_date_table", "mc_position");
                this.mainDataSource?.activeRow?.set("appt_date_field", "position_date");
            }
            this.mainDataSource?.activeRow?.set("grace_period_hours", 0);
            this.mainDataSource?.activeRow?.set("grace_period_minutes", 1);
            this.mainDataSource?.activeRow?.set("grace_period", 1);
            // Minimum interval defaults to 0 hrs / 0 min for ETA and Position
            this.mainDataSource?.activeRow?.set("minimum_interval_hours", 0);
            this.mainDataSource?.activeRow?.set("minimum_interval_minutes", 0);
            this.mainDataSource?.activeRow?.set("minimum_interval", 0);

            // ETA/Position: resend access disabled, reset all resend values (Swing: setResendAccess(false, true))
            this.mainDataSource?.activeRow?.set("resend_if_early", false);
            this.mainDataSource?.activeRow?.set("resend_early_grace_period_hours", 0);
            this.mainDataSource?.activeRow?.set("resend_early_grace_period_minutes", 0);
            this.mainDataSource?.activeRow?.set("resend_early_grace", 0);
            this.mainDataSource?.activeRow?.set("resend_if_late", false);
            this.mainDataSource?.activeRow?.set("resend_late_grace_period_hours", 0);
            this.mainDataSource?.activeRow?.set("resend_late_grace_period_minutes", 0);
            this.mainDataSource?.activeRow?.set("resend_late_grace", 0);
            if (this.checkboxResendIfEarly) {
                this.checkboxResendIfEarly.checked = false;
                this.checkboxResendIfEarly.enabled = false;
            }
            if (this.checkboxResendIfLate) {
                this.checkboxResendIfLate.checked = false;
                this.checkboxResendIfLate.enabled = false;
            }
            this.checkboxResendEarReqSrc.checked = false;
            this.checkboxResendEarReqSrc.enabled = false;
            this.checkboxResendLatReqSrc.checked = false;
            this.checkboxResendLatReqSrc.enabled = false;
        }

        // Refresh the display to show the updated values
        this.textboxStatusDateTable.displayData(this.mainDataSource?.activeRow, null, 0);
        this.textboxStatusDateField.displayData(this.mainDataSource?.activeRow, null, 0);
        this.textboxApptDateTable.displayData(this.mainDataSource?.activeRow, null, 0);
        this.textboxApptDateField.displayData(this.mainDataSource?.activeRow, null, 0);
        this.textboxGracePeriodHours.displayData(this.mainDataSource?.activeRow, null, 0);
        this.textboxGracePeriodMinutes.displayData(this.mainDataSource?.activeRow, null, 0);
    }

    private setInboundEventTypeDefaults(eventType: string, isAddMode: boolean) {
        const defaults = EdiEventStatusTableEdit.INBOUND_ADD_FIELD_DEFAULTS[eventType];
        if (defaults) {
            if (!isAddMode) {
                // Preserve show_on_rpt when changing event type on an existing record
                const currentShowOnRpt = this.mainDataSource?.activeRow?.get("show_on_rpt");
                this.mainDataSource?.activeRow?.setValues(defaults);
                if (currentShowOnRpt !== undefined) {
                    this.mainDataSource?.activeRow?.set("show_on_rpt", currentShowOnRpt);
                }
            } else {
                this.mainDataSource?.activeRow?.setValues(defaults);
            }
        }
    }

    stopTypeAfterDropDownSelection() {
        this.setFieldVisibility();
        this.setFieldRequired();
        this.setPanelBorderColor();

        // For outbound Position events, update pickup position fields based on stop type
        const direction = this.mainDataSource?.activeRow?.get("direction");
        const eventType = this.mainDataSource?.activeRow?.get("event_type");
        if (direction === EdiEventStatusTableEdit.OUTBOUND &&
            eventType === EdiEventStatusTableEdit.POSITION_EVENT_TYPE) {
            const stopType = this.mainDataSource?.activeRow?.get("stop_type");
            const isPickupStop = stopType === EdiEventStatusTableEdit.ORIGIN_STOP_TYPE ||
                stopType === EdiEventStatusTableEdit.PICKUP_STOP_TYPE;
            this.checkboxPickupPosPrevDelivered.visible = isPickupStop;
            this.textboxPickupPosCreateHours.visible = isPickupStop;
            this.textboxPickupPosCreateMinutes.visible = isPickupStop;
            this.imagePickupInfo.visible = isPickupStop;
            this.textboxPickupPosStopOption.visible = isPickupStop;
        }
    }

    setFieldVisibility() {
        const eventType = this.mainDataSource?.activeRow?.get("event_type");
        const stopType = this.mainDataSource?.activeRow?.get("stop_type");
        const direction = this.mainDataSource?.activeRow?.get("direction");

        if (direction === EdiEventStatusTableEdit.OUTBOUND) {
            let config = EdiEventStatusTableEdit.FIELD_VISIBILITY_CONFIG[eventType];

            // Handle position event type with different stop configurations
            if (eventType === EdiEventStatusTableEdit.POSITION_EVENT_TYPE) {
                const isPickupStop = stopType === EdiEventStatusTableEdit.ORIGIN_STOP_TYPE ||
                    stopType === EdiEventStatusTableEdit.PICKUP_STOP_TYPE;
                config = isPickupStop ? config.pickup : config.delivery;
            }

            if (config) {
                this.applyFieldVisibilityConfig(config);
            }
        } else if (direction === EdiEventStatusTableEdit.INBOUND) {
            this.setGeneralPanelInboundVisibility();
        }
    }

    setAddVisibility() {
        const direction = this.mainDataSource?.activeRow?.get("direction");

        if (direction === EdiEventStatusTableEdit.OUTBOUND) {
            Object.keys(EdiEventStatusTableEdit.NEW_RECORD).forEach(fieldName => {
                if (this[fieldName] && typeof this[fieldName].visible !== 'undefined') {
                    this[fieldName].visible = EdiEventStatusTableEdit.NEW_RECORD[fieldName];
                }
            });
            this.setEventTypeItemsByDirection(EdiEventStatusTableEdit.OUTBOUND);
        } else {
            Object.keys(EdiEventStatusTableEdit.NEW_RECORD_INBOUND).forEach(fieldName => {
                if (this[fieldName] && typeof this[fieldName].visible !== 'undefined') {
                    this[fieldName].visible = EdiEventStatusTableEdit.NEW_RECORD_INBOUND[fieldName];
                }
            });
            this.setEventTypeItemsByDirection(EdiEventStatusTableEdit.INBOUND);

            // Initialize inbound status date table items
            this.setInboundStatusDateTableDefaults();
        }
    }

    private setInboundStatusDateTableDefaults() {
        // Set default status date table items for inbound events
        this.textboxStatusDateTableIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STATUS_DATE_TABLE;

        // Set initial default value if event type is already set
        const eventType = this.mainDataSource?.activeRow?.get("event_type");
        if (eventType) {
            const inboundDefaultValues = EdiEventStatusTableEdit.INBOUND_ADD_FIELD_DEFAULTS[eventType];
            if (inboundDefaultValues) {
                this.mainDataSource.activeRow.setValues(inboundDefaultValues);

                // Set appropriate dropdown items and enabled state for status date field based on event type
                if (eventType === EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE) {
                    this.textboxStatusDateFieldIn.enabled = true;
                    this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.INFORMATIONAL_STATUS_FIELDS;
                } else if (eventType === EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE) {
                    this.textboxStatusDateFieldIn.enabled = true;
                    this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.APPOINTMENT_STATUS_FIELDS;
                } else if (eventType === EdiEventStatusTableEdit.ETA_EVENT_TYPE ||
                    eventType === EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE ||
                    eventType === EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE) {
                    this.textboxStatusDateFieldIn.enabled = false;
                    this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STOP_DATE_FIELDS;
                } else {
                    this.textboxStatusDateFieldIn.enabled = false;
                }

                // Refresh the display to show the updated values
                this.textboxStatusDateTableIn.displayData(this.mainDataSource?.activeRow, null, 0);
                this.textboxStatusDateFieldIn.displayData(this.mainDataSource?.activeRow, null, 0);
            }
        }
    }

    /**
     * Sets the status date table and field values for inbound events based on event type
     */
    private setInboundStatusDateFields() {
        const eventType = this.mainDataSource?.activeRow?.get("event_type");
        const direction = this.mainDataSource?.activeRow?.get("direction");

        if (!eventType || !this.mainDataSource?.activeRow || direction !== EdiEventStatusTableEdit.INBOUND) {
            return;
        }

        const inboundDefaults = EdiEventStatusTableEdit.INBOUND_ADD_FIELD_DEFAULTS[eventType];
        if (!inboundDefaults) {
            return;
        }

        this.mainDataSource.activeRow.set("status_date_table", inboundDefaults.status_date_table);

        if (inboundDefaults.status_date_field) {
            this.mainDataSource.activeRow.set("status_date_field", inboundDefaults.status_date_field);
        }

        // Configure the dropdown items and enabled state for status date table
        this.textboxStatusDateTableIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STATUS_DATE_TABLE;

        // Configure the dropdown items and enabled state for status date field based on event type
        switch (eventType) {
            case EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE:
                this.textboxStatusDateFieldIn.enabled = true;
                this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.INFORMATIONAL_STATUS_FIELDS;
                // Clear the field value for informational events since user needs to select from dropdown
                this.mainDataSource.activeRow.set("status_date_field", null);
                break;

            case EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE:
                this.textboxStatusDateFieldIn.enabled = true;
                this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.APPOINTMENT_STATUS_FIELDS;
                break;

            case EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE:
            case EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE:
            case EdiEventStatusTableEdit.ETA_EVENT_TYPE:
                this.textboxStatusDateFieldIn.enabled = false;
                this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STOP_DATE_FIELDS;
                break;

            default:
                this.textboxStatusDateFieldIn.enabled = false;
                this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STOP_DATE_FIELDS;
                break;
        }

        // Refresh the display to show the updated values
        this.textboxStatusDateTableIn.displayData(this.mainDataSource?.activeRow, null, 0);
        this.textboxStatusDateFieldIn.displayData(this.mainDataSource?.activeRow, null, 0);
    }

    setFieldRequired() {
        const eventType = this.mainDataSource?.activeRow?.get("event_type");
        const direction = this.mainDataSource?.activeRow?.get("direction");

        if (direction === EdiEventStatusTableEdit.OUTBOUND) {
            const config = EdiEventStatusTableEdit.FIELD_REQUIRED_CONFIG[eventType];

            if (config) {
                this.applyFieldRequiredConfig(config);
            }
        } else if (direction === EdiEventStatusTableEdit.INBOUND) {
            this.setGeneralPanelInboundRequired();
        }
    }

    setPanelBorderColor() {
        const eventType = this.mainDataSource?.activeRow?.get("event_type");
        const direction = this.mainDataSource?.activeRow?.get("direction");
        if (direction !== EdiEventStatusTableEdit.OUTBOUND) {
            return;
        }

        if (eventType === EdiEventStatusTableEdit.POSITION_EVENT_TYPE || eventType === EdiEventStatusTableEdit.ORDER_HISTORY_EVENT_TYPE) {
            this.panelCreatedAt.borderRightColor = "default.lightest";
            this.panelCreatedAt.borderRightWidth = 1;
            this.panelStatusRequired.borderLeftColor = "";
            this.panelStatusRequired.borderLeftWidth = null;
        } else {
            this.panelCreatedAt.borderRightColor = "";
            this.panelCreatedAt.borderRightWidth = null;
            this.panelStatusRequired.borderLeftColor = "default.lightest";
            this.panelStatusRequired.borderLeftWidth = 1;
        }
    }

    tableRequiredFieldOnRowCreate(event: TableRowCreationEvent) {
        const row = event.target as TableRow;
        const activeRow = this.mainDataSource?.activeRow;
        if (!activeRow) return;

        // Use reply partner information if available, otherwise use main partner info
        const eventId = activeRow.get("id");

        row.data.set("event_id", eventId);
    }

    /**
         * Sets up common table required field handlers for EDI validation rules
         * @param transactionType The transaction type for the profile (e.g., "214", "204", etc.)
         * @param isGroupRule Whether this is for group rules or individual rules
         * @param dialogTitle Optional custom title for the validation rules dialog
         */
    public setupTableRequiredFieldHandlers(transactionType: string, isGroupRule: boolean = false, dialogTitle?: string): void {
        if (!this.tableRequiredField) return;

        const defaultTitle = "DataFusion Data Validation Rules";
        const title = dialogTitle || defaultTitle;

        this.tableRequiredField.onEditLayoutLoaded = (decorator: any, tableRow: any) => {
            const reqRulesLayout = decorator.layout as EdiRequiredFieldStatus;
            reqRulesLayout.transactionType = transactionType;
            reqRulesLayout.isGroupRule = isGroupRule;
            reqRulesLayout.tableEdiDataRule.doOnRowDelete = null;
            reqRulesLayout.version = this.version;
            reqRulesLayout.partnerId = this.partnerId;
            decorator.labelTitle.text = title;

            const superOnSave = decorator.onSave;
            decorator.onSave = async (updatedRow: any) => {
                if (reqRulesLayout.mainDataSource.validate()) {
                    const rules = reqRulesLayout.tableEdiDataRule?.data;
                    updatedRow.set('data_rules', rules);
                    const rowToSend = updatedRow?.data ? updatedRow.data : updatedRow;
                    const response = await Api.post("lme/datafusion/set-rules-description", { required_fields: rowToSend, version: reqRulesLayout.version });
                    updatedRow.set('rule_description', response.data[0].rules_description);
                    superOnSave(updatedRow);
                }
            };
        };

        // Set up CRUD manager
        this.tableRequiredField.crudManager.showCrud = (mode: DataSourceMode, props?: Partial<CrudDecoratorProps>, dataHeaderProps?: Partial<DataHeaderProps>) => {
            const layoutName = "lme/datafusion/EdiRequiredFieldStatus";
            if (layoutName == null) {
                return;
            }
            const layout = Layout.getLayout(layoutName) as EdiRequiredFieldStatus;
            layout.version = this.version;
            layout.partnerId = this.partnerId;
            layout.transactionType = transactionType;
            layout.isGroupRule = isGroupRule;

            const crudDecorator = new CrudDecorator({
                layout: layout,
                mode: mode,
                headerProps: {
                    showClose: true,
                    showSaveAndClose: true,
                    title: title,
                    doAfterClose: async (event) => {
                        const closeEvent = event as unknown as CrudDecoratorCloseEvent;
                        if (!closeEvent.isCancel()) {
                            const dataSource = layout.mainDataSource.activeRow;
                            const dataRules = layout.tableEdiDataRule?.data || [];
                            dataSource?.set("data_rules", dataRules);
                            for (const row of this.tableRequiredField.allRows) {
                                if (row.data === dataSource || row.data.get("id") === dataSource?.get("id")) {
                                    row.data.set("version", layout.version);
                                    row.data.set("data_rules", dataRules);
                                    try {
                                        const response = await Api.post("lme/datafusion/set-rules-description", { required_fields: row.data, version: layout.version });
                                        row.data.set("rule_description", response.data[0].rules_description);
                                    } catch (error) {
                                        row.data.set("rule_description", "");
                                    }
                                    this.tableRequiredField.displayData(row.data, this.tableRequiredField.dataSource.data, 0);
                                    break;
                                }
                            }
                        }
                    },
                    ...dataHeaderProps,
                },
                doAfterSlideIn: async () => {
                    layout.addLayoutLoadListener(() => {
                        layout.tableEdiDataRule?.dataSource?.setRowsAndMode(DataSourceMode.NONE, []);
                    });
                },
                ...props
            });
            crudDecorator.slideIn({ speed: 200 });
        };

        this.tableRequiredField.addButtonCaption = "Add";
    }

    /**
     * Applies field visibility configuration to all form elements
     * @param config The configuration object containing visibility settings
     */
    private applyFieldVisibilityConfig(config: any) {
        // Set basic field visibility
        Object.keys(config).forEach(fieldName => {
            if (this[fieldName] && typeof this[fieldName].visible !== 'undefined') {
                this[fieldName].visible = config[fieldName];
            }
        });
    }

    /**
     * Applies field required configuration to all form elements
     * @param config The configuration object containing required settings
     */
    private applyFieldRequiredConfig(config: any) {
        // Set required field configuration
        Object.keys(config).forEach(fieldName => {
            if (this[fieldName] && typeof this[fieldName].required !== 'undefined') {
                this[fieldName].required = config[fieldName];
                this[fieldName].requiredDuringAdd = config[fieldName];
                this[fieldName].requiredDuringEdit = config[fieldName];
                this[fieldName].requiredDuringSearch = config[fieldName];
            }
        }
        );
    }

    /**
     * Applies inbound general panel field visibility configuration
     * @param config The configuration object containing visibility settings for inbound general panel
     */
    private applyInboundGeneralFieldVisibilityConfig(config: any) {
        Object.keys(config).forEach(fieldName => {
            if (this[fieldName] && typeof this[fieldName].visible !== 'undefined') {
                this[fieldName].visible = config[fieldName];
            }
        });
    }

    /**
     * Applies inbound general panel field required configuration
     * @param config The configuration object containing required settings for inbound general panel
     */
    private applyInboundGeneralFieldRequiredConfig(config: any) {
        Object.keys(config).forEach(fieldName => {
            if (this[fieldName] && typeof this[fieldName].required !== 'undefined') {
                this[fieldName].required = config[fieldName];
                this[fieldName].requiredDuringAdd = config[fieldName];
                this[fieldName].requiredDuringEdit = config[fieldName];
                this[fieldName].requiredDuringSearch = config[fieldName];
            }
        });
    }

    /**
     * Maps required field data to a ModelRow, handling both direct properties and _data fallbacks
     * @param modelRow The ModelRow to populate
     * @param field The required field data object
     */
    private mapRequiredFieldToModelRow(modelRow: ModelRow, field: any): void {
        const fieldMappings = [
            { field: "id", value: field.id ?? field["_data"]?.id },
            { field: "alt_partner_id", value: field.alt_partner_id ?? field["_data"]?.alt_partner_id },
            { field: "company_id", value: field.company_id ?? field["_data"]?.company_id },
            { field: "direction", value: field.direction ?? field["_data"]?.direction },
            { field: "error_code", value: field.error_code ?? field["_data"]?.error_code },
            { field: "error_descr", value: field.error_descr ?? field["_data"]?.error_descr },
            { field: "event_id", value: field.event_id ?? field["_data"]?.event_id },
            { field: "field_name", value: field.field_name ?? field["_data"]?.field_name },
            { field: "group_id", value: field.group_id ?? field["_data"]?.group_id },
            { field: "location_id", value: field.location_id ?? field["_data"]?.location_id },
            { field: "parent_row_id", value: field.parent_row_id ?? field["_data"]?.parent_row_id },
            { field: "parent_row_type", value: field.parent_row_type ?? field["_data"]?.parent_row_type },
            { field: "partner_id", value: field.partner_id ?? field["_data"]?.partner_id },
            { field: "pass_when_type", value: field.pass_when_type ?? field["_data"]?.pass_when_type },
            { field: "rule_type", value: field.rule_type ?? field["_data"]?.rule_type },
            { field: "sequence", value: field.sequence ?? field["_data"]?.sequence },
            { field: "table_name", value: field.table_name ?? field["_data"]?.table_name },
            { field: "transaction_set", value: field.transaction_set ?? field["_data"]?.transaction_set },
            { field: "version", value: field.version ?? field["_data"]?.version },
            { field: "which_stop", value: field.which_stop ?? field["_data"]?.which_stop },
            { field: "is_active", value: field.is_active ?? field["_data"]?.is_active },
            { field: "data_rules", value: field.data_rules ?? field["_data"]?.data_rules },
            { field: "rule_description", value: field.rule_description ?? field["_data"]?.rule_description }
        ];

        fieldMappings.forEach(mapping => {
            modelRow.set(mapping.field, mapping.value);
        });

        const lookupModel = field?._lookup_field_name ?? field["_data"]?._lookup_field_name;
        if (lookupModel) {
            modelRow.setLookupModelData("field_name", lookupModel);
        }
        const locationModel = field?._lookup_location_id ?? field["_data"]?._lookup_location_id;
        if (locationModel) {
            modelRow.setLookupModelData("location_id", locationModel);
        }
    }

    private mapCreationRuleToModelRow(modelRow: ModelRow, field: any): void {
        const fieldMappings = [
            { field: "id", value: field.id ?? field["_data"]?.id },
            { field: "descr", value: field.descr ?? field["_data"]?.descr },
            { field: "is_active", value: field.is_active ?? field["_data"]?.is_active },
            { field: "company_id", value: field.company_id ?? field["_data"]?.company_id },
            { field: "parent_row_id", value: field.parent_row_id ?? field["_data"]?.parent_row_id },
            { field: "parent_row_type", value: field.parent_row_type ?? field["_data"]?.parent_row_type },
            { field: "rule_description", value: field.rule_description ?? field["_data"]?.rule_description },
            { field: "sequence", value: field.sequence ?? field["_data"]?.sequence },
            { field: "required_fields", value: field.required_fields ?? field["_data"]?.required_fields }
        ];

        fieldMappings.forEach(mapping => {
            modelRow.set(mapping.field, mapping.value);
        });
    }

    setAddField(event: DropdownSelectionEvent) {
        if (!event.userInitiatedChange) {
            return;
        }

        const eventType = event.selection?.value;
        const direction = this.mainDataSource?.activeRow?.get("direction");

        if (direction === EdiEventStatusTableEdit.OUTBOUND) {
            const defaultValues = EdiEventStatusTableEdit.ADD_FIELD_DEFAULTS[eventType];
            if (defaultValues) {
                this.mainDataSource.activeRow.setValues(defaultValues);
            }
        } else if (direction === EdiEventStatusTableEdit.INBOUND) {
            const inboundDefaultValues = EdiEventStatusTableEdit.INBOUND_ADD_FIELD_DEFAULTS[eventType];
            if (inboundDefaultValues) {
                this.mainDataSource.activeRow.setValues(inboundDefaultValues);

                // Set appropriate dropdown items and enabled state for status date field based on event type
                if (eventType === EdiEventStatusTableEdit.INFORMATIONAL_EVENT_TYPE) {
                    this.textboxStatusDateFieldIn.enabled = true;
                    this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.INFORMATIONAL_STATUS_FIELDS;
                } else if (eventType === EdiEventStatusTableEdit.APPOINTMENT_EVENT_TYPE) {
                    this.textboxStatusDateFieldIn.enabled = true;
                    this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.APPOINTMENT_STATUS_FIELDS;
                } else if (eventType === EdiEventStatusTableEdit.ETA_EVENT_TYPE ||
                    eventType === EdiEventStatusTableEdit.ARRIVE_STOP_EVENT_TYPE ||
                    eventType === EdiEventStatusTableEdit.DEPART_STOP_EVENT_TYPE) {
                    this.textboxStatusDateFieldIn.enabled = false;
                    this.textboxStatusDateFieldIn.items = EdiEventStatusTableEdit.DROPDOWN_ITEMS.STOP_DATE_FIELDS;
                } else {
                    this.textboxStatusDateFieldIn.enabled = false;
                }

                // Refresh the inbound status date fields to show the updated values
                this.textboxStatusDateTableIn.displayData(this.mainDataSource?.activeRow, null, 0);
                this.textboxStatusDateFieldIn.displayData(this.mainDataSource?.activeRow, null, 0);
            }
        }

        this.setEnabledFields();
    } setStatusDateTableItems(event: DropdownSelectionEvent) {
        if (!event.userInitiatedChange) {
            return;
        }
        const isStop = event.selection?.value === EdiEventStatusTableEdit.STOP_EVENT_TYPE;
        this.textboxStatusDateTable.items = isStop ? EdiEventStatusTableEdit.DROPDOWN_ITEMS.STATUS_DATE_TABLE_STOP_ONLY : EdiEventStatusTableEdit.DROPDOWN_ITEMS.STATUS_DATE_TABLE;
        this.textboxStatusDateTable.displayData(this.mainDataSource?.activeRow, null, 0);

        // Also update inbound status date table items for inbound direction
        const direction = this.mainDataSource?.activeRow?.get("direction");
        if (direction === EdiEventStatusTableEdit.INBOUND) {
            this.textboxStatusDateTableIn.items = isStop ? EdiEventStatusTableEdit.DROPDOWN_ITEMS.STATUS_DATE_TABLE_STOP_ONLY : EdiEventStatusTableEdit.DROPDOWN_ITEMS.STATUS_DATE_TABLE;
            this.textboxStatusDateTableIn.displayData(this.mainDataSource?.activeRow, null, 0);
        }
    }

    setEnabledFields() {
        if (this.checkboxResendIfEarly.checked) {
            this.checkboxResendEarReqSrc.enabled = true;
        } else {
            this.checkboxResendEarReqSrc.enabled = false;
        }

        if (this.checkboxResendIfLate.checked) {
            this.checkboxResendLatReqSrc.enabled = true;
        } else {
            this.checkboxResendLatReqSrc.enabled = false;
        }
    }

    onStatusCodeOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            const selection = event.selection;
            this.mainDataSource?.activeRow?.set("descr", selection.get("description"));
        }
    }

    /**
     * Opens a help window with the specified title and content
     * @param title The title for the help window
     * @param content The HTML content to display
     */
    private openHelpWindow(title: string, content: string) {
        const screenWidth = screen.width;
        const screenHeight = screen.height;
        const windowWidth = Math.floor(screenWidth * 0.5);
        const windowHeight = screenHeight;

        // Open a new window to display help text
        const helpWindow = window.open('', '_blank', `width=${windowWidth},height=${windowHeight},scrollbars=yes,resizable=yes`);
        if (helpWindow) {
            // Create the HTML structure using modern DOM methods
            const doc = helpWindow.document;

            // Set the title
            doc.title = title;

            // Create and add CSS styles
            const style = doc.createElement('style');
            style.textContent = this.HELP_WINDOW_CSS;
            doc.head.appendChild(style);

            // Create the main content
            const h1 = doc.createElement('h1');
            h1.textContent = title;
            doc.body.appendChild(h1);

            const placeholderDiv = doc.createElement('div');
            placeholderDiv.className = 'placeholder';

            const contentDiv = doc.createElement('div');
            contentDiv.innerHTML = content;
            placeholderDiv.appendChild(contentDiv);

            doc.body.appendChild(placeholderDiv);

            helpWindow.focus();
        }
    }

    /** This is an event handler for the onRowExpand event of tableReqdFldGrp. */
    tableReqdFldGrpOnRowExpand(event: TableRowExpansionEvent) {
        //lme/datafusion/EdiReqdFldGrpExpanded
        const tableRow: TableRow = event.target as TableRow;
        const expandPanel = event.expandComponentParent as Panel;
        const modelRow: ModelRow = tableRow.data
        const layoutToExpand: EdiReqdFldGrpExpandedStatus = expandPanel.findComponentById("layoutEdiRequiredFieldsExpanded") as EdiReqdFldGrpExpandedStatus;

        // Set the private variables in the expanded layout
        if (layoutToExpand) {
            layoutToExpand.version = this.mainDataSource?.activeRow?.get("version");
            layoutToExpand.partnerId = this.mainDataSource?.activeRow?.get("partner_id");
            layoutToExpand.altPartnerId = this.mainDataSource?.activeRow?.get("alt_partner_id");
            layoutToExpand.parentDataSource = this.mainDataSource;
            layoutToExpand.groupId = modelRow.get("id");
            layoutToExpand.groupRow = modelRow;
            layoutToExpand.transactionType = "214";
        }
        const requiredFields = modelRow.get("required_fields");
        if (requiredFields) {
            const modelRows: ModelRow[] = [];
            requiredFields.forEach((field: any) => {
                const row = new ModelRow("lme/datafusion/edi-required-field");
                this.mapRequiredFieldToModelRow(row, field);
                modelRows.push(row);
            });
            layoutToExpand?.mainDataSource.setRowsAndMode(DataSourceMode.NONE, modelRows);
        }

    }

    /** This is an event handler for the onRowDisplay event of tableReqdFldGrp. */
    tableReqdFldGrpOnRowDisplay(event: TableRowDisplayEvent) {
        const textDescr = event.getTableRow().findComponentById("textboxRuleGrpDescr") as Textbox;
        const textSequence = event.getTableRow().findComponentById("textboxSequence") as Textbox;
        if (textSequence && textSequence?.text === "0") {
            textSequence.required = false;
            textSequence.visible = false;
        }
        const row: TableRow = event.getTableRow();
        if (textDescr && StringUtil.isEmptyString(row.data.get("descr"))) {
            textDescr.text = row.data.get("rule_description");
        }

    }

    /** This is an event handler for the onContentsChanged event of tableReqdFldGrp. */
    tableReqdFldGrpOnContentsChanged(event: TableContentsChangedEvent) {
        if (event.getAction() === TableAction.DELETE) {
            this.updateReqdFldGrpQuickAddSequence();
        }
    }

    private updateReqdFldGrpQuickAddSequence() {
        const quickAddRow = this.tableReqdFldGrp.quickAddRow;
        if (quickAddRow) {
            const existingRows = this.tableReqdFldGrp.allRows.filter(r => r.mode !== TableRowMode.QUICK_ADD);
            const nextSequence = existingRows.length + 1;
            quickAddRow.data.set("sequence", nextSequence);
            const textSequence = quickAddRow.findComponentById("textboxSequence") as Textbox;
            if (textSequence) {
                textSequence.text = String(nextSequence);
            }
        }
    }

    /** This is an event handler for the afterTableRowMove event of tableReqdFldGrp. */
    tableReqdFldGrpAfterTableRowMove(event: TableRowMoveEvent) {
        // Update sequence field in the data to match the new row order
        this.tableReqdFldGrp.allRows.forEach((row, index) => {
            row.data.set("sequence", index + 1);
        });
        this.mainDataSource.mode = DataSourceMode.UPDATE;
    }

    /** This is an event handler for the onRowCreate event of tableReqdFldGrp. */
    tableReqdFldGrpOnRowCreate(event: TableRowCreationEvent) {
        const tableRow = event.target as TableRow;
        const modelRow = tableRow.data as ModelRow;

        // Only set sequence for user-initiated row creation (quick-add), not data loading
        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            const existingRows = this.tableReqdFldGrp.allRows.filter(r => r !== tableRow && r.mode !== TableRowMode.QUICK_ADD);
            const nextSequence = existingRows.length + 1;
            modelRow.set("sequence", nextSequence);
            const textSequence = tableRow.findComponentById("textboxSequence") as Textbox;
            if (textSequence) {
                textSequence.text = String(nextSequence);
            }
        }
    }

    ruleDescriptionOnChange(event: ChangeEvent) {
        if (event.userInitiatedChange && event.newValue !== event.oldValue) {
            const textBox = event.target as Textbox;
            const modelRow = textBox.getRelevantModelRow();
            if (modelRow) {
                modelRow.set("descr", event.newValue);
            }
        }
    }

    /**
     * Returns the HTML content for pickup position option information
     */
    private getPickupInfoContent(): string {
        return `
        <h2>'Start creation when the previous loaded movement of the equipment has been delivered'</h2>
        <p>This option only applies to Asset companies.</p>
        <br>
        <p>This setting determines if the 'en route to pickup' position can be created based on whether the preassigned equipment's current movement has been delivered.
        This option should be selected if you wish for 'en route to pickup' positions to only start generating for a preassigned order when the equipment's current movement has been delivered.
        If both a trailer and tractor are preassigned to an order, both must deliver their current movement (even if they are separate movements) before this option will allow 'en route to pickup' position generation.</p>
        <br>
        <h2>'Generate when current stop's [value] is within [a specified number of] hours/minutes'</h2>
        <p>This setting can limit how soon 'en route to pickup' positions will generate. When this 'en route to pickup' position is being reviewed for creation, the system will take the stop option [value] specified (
        Early scheduled arrival time or ETA) and subtract the hours/minutes value entered. If the resulting time has already passed, then you are within the timeframe you've specified to send a status,
        then a new 'en route to pickup' position status will be created (provided all other status validation passes).</p>
        <br>
        <p>For instance, if the trading partner requires that you only send 'en route to pickup' positions when your driver is within 2 hours of arriving at the stop,
        then you would select the 'Early scheduled arrival time' option and enter 2 hours and 0 minutes into the time options.
        Therefore, the system will only generate these 'en route to pickup' positions if the stop's early appointment time is within 2 hours of the time of status generation.
        </p>
      `;
    }

    /**
     * Returns the HTML content for resend information
     */
    private getResendInfoContent(): string {
        return `
        <h2>'Resend if new time differs by hours/minutes':</h2>
        <p>This setting controls how new an ETA/position date must be before a new status can be sent. The latest information is compared against the last instance of the shipment status that was sent;
        if the difference between the two times matches the value entered in the 'Resend if new time differs by' field, then a new instance of the shipment status will be created.</p>
        <br>
        <p>Using ETAs as an example, if the last ETA shipment status information sent to the partner was at 1/1 @ 1000 (am), and the 'Resend if new time differs by' setting is set to 0 hours 1 minute, then a new shipment status will not be created
        until position information is available that is at least one minute different (1/1 @ 1001 (am)).</p>
        <br>
        <p>If the setting is left with a value of 0 hours 0 minutes, then it will be possible to send a new shipment status every time shipment status processing is invoked, even if the ETA/position date matches the last one sent to the trading partner.</p>
        <br>
        <h2>'Send a new status no more often than every hours/minutes':</h2>
        <p>This setting controls how often a new ETA/position shipment status will be allowed to be created. The current time is compared against the time at which the last instance of the shipment status was sent to the trading partner;
        if the difference between the two times matches the value entered in the 'Send a new status no more often than every' field, then a new instance of the shipment status will be created.</p>
        <br>
        <p>Using positions as an example, if the last position shipment status was sent to the partner at 1/1 @ 0800 (am), and the 'Send a new status no more often than every' setting is set to 1 hour 0 minutes, then a new shipment status will not be created
        until at least 1/1 @ 0900 (am).</p>
        <br>
        <p>If the setting is left with a value of 0 hours 0 minutes, then it will be possible to send a new shipment status every time shipment status processing is invoked, regardless of how long it has been since the last instance of the status was sent to the trading partner.</p>
        <br>
        <p><b>*Both conditions must be satisfied before a new status will be created.</b></p>
      `;
    }

    allowedToPopulateArrivalDateTimeOnChange(event: ChangeEvent) {
        if (event.userInitiatedChange && event.newValue !== event.oldValue) {
            this.textboxReqSrcIn.visible = event.newValue === true;
            this.checkboxCreateServiceIncident.visible = event.newValue === true;
        }
    }

    public get partnerId(): string {
        return this._partner_id;
    }

    public set partnerId(value: string) {
        this._partner_id = value;
    }

    public get version(): string {
        return this._version;
    }

    public set version(value: string) {
        this._version = value;
    }

    public get direction(): string {
        return this._direction;
    }

    public set direction(value: string) {
        this._direction = value;
    }

    public get altPartnerId(): string {
        return this._alt_partner_id;
    }

    public set altPartnerId(value: string) {
        this._alt_partner_id = value;
    }

    public get isLoadingData(): boolean {
        return this._isLoadingData;
    }

    public set isLoadingData(value: boolean) {
        this._isLoadingData = value;
    }

    /** This is an event handler for the beforeDynamicDbDisplayValueSearch event of textboxReqSrcIn. */
    textboxReqSrcInBeforeDynamicDbDisplayValueSearch(event: DynamicDbDisplayValueSearchEvent) {
        const direction = "I";
        event.addAddlValue("direction", direction);
    }

    /** This is an event handler for the beforeDynamicDbDisplayValueSearch event of textboxReqSrc. */
    textboxReqSrcBeforeDynamicDbDisplayValueSearch(event: DynamicDbDisplayValueSearchEvent) {
        const direction = "O";
        event.addAddlValue("direction", direction);
    }

/** This is an event handler for the onDataDisplay event of textboxStatusCode. */
  textboxStatusCodeOnDataDisplay(event: DataDisplayEvent) {
    // Remove leading "-" if present (after trimming whitespace)
    if (this.textboxStatusCode.text) {
      const trimmedText = this.textboxStatusCode.text.trim();
      if (trimmedText.startsWith("-")) {
        this.textboxStatusCode.text = trimmedText.substring(1);
      }
    }
  }
}
